/**
 * Production-safe logging utility
 * Automatically disables console logs in production
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

export const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  error: (...args) => {
    // Always log errors, even in production
    console.error(...args);
  },
  
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  }
};

// For payment-specific logging
export const paymentLogger = {
  log: (message, data) => {
    if (isDevelopment) {
      console.log(`💳 ${message}`, data || '');
    }
  },
  
  error: (message, error) => {
    // Always log payment errors
    console.error(`💥 Payment Error: ${message}`, error || '');
  },
  
  success: (message, data) => {
    if (isDevelopment) {
      console.log(`✅ Payment Success: ${message}`, data || '');
    }
  }
};

export default logger;